import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import { getAppSettings, getAuthToken } from '../store/sitecoreSlice';
import { useParams } from 'react-router-dom';

export const useApiHeaders = () => {

  const appSettings = useSelector(getAppSettings);
  const unauthtoken = useSelector(getAuthToken)
  const lang = useParams().lang ;
  const authServiceUrl = appSettings.applicationBaseUrl;

  const authHeader: any = {
    "application-code": appSettings?.applicationCode,
    "entity": appSettings?.entity,
    "Channel-Id": appSettings?.channelId,
    "Financial-Id": appSettings?.financialId,
    "Unique-Reference-Code": uuid().replaceAll('-', ''),
    "contentType": "application/json",
    'Client-Timestamp': Date.now(),
    "Accept-Language": lang,
    "unauthtoken": unauthtoken
  }

  const unAuthHeader: any = {
    "application-code": appSettings?.applicationCode,
    "entity": appSettings?.entity,
    "Channel-Id": appSettings?.channelId,
    "Financial-Id": appSettings?.financialId,
    "Unique-Reference-Code": uuid().replaceAll('-', ''),
    "contentType": "application/json",
    'Client-Timestamp': Date.now(),
    "Accept-Language": lang,
    "unauthtoken": unauthtoken
  }

  const plainHeader: any = {
    "application-code": appSettings?.applicationCode,
    "entity": appSettings?.entity,
    "Channel-Id": appSettings?.channelId,
    "Financial-Id": appSettings?.financialId,
    "Unique-Reference-Code": uuid().replaceAll('-', ''),
    "contentType": "application/json",
    'Client-Timestamp': Date.now(),
  }

  const unAuthTokenAPI = appSettings.unauthTokenAPI;

  return {
    unAuthTokenAPI,
    authHeader,
    unAuthHeader,
    appSettings,
    plainHeader,
    authServiceUrl
  }
}